import React, { useState } from 'react';
import { decodeHTML } from 'entities';
import { notify } from '../../../../helpers/notifications';

const TextAreaValue = ({
  field,
  response,
  isEditing,
  adminField,
  handleTextResponseUpdate,
}) => {
  const [text, setText] = useState(
    response && response.value ? decodeHTML(response.value) : ''
  );
  let width = field.width === 1 ? 'full' : field.width === 2 ? 'half' : 'third';

  const handleSave = (e) => {
    handleTextResponseUpdate(e, response).then((newValue) => {
      let htmlSafeValue = newValue ? decodeHTML(newValue) : '';
      if (htmlSafeValue != text) {
        notify.info('Note: HTML tags or extra spaces have been removed', {
          showOnlyTheLastOne: false,
          timeout: 6000,
        });
        setText(htmlSafeValue);
      }
    });
  };

  return (
    <div className={'input-group ' + width}>
      <label
        className={
          response?.value?.length > 0 || isEditing || adminField ? '' : 'empty'
        }
      >
        {field.name + ': '}
      </label>
      {adminField && field.help_text && (
        <p className='admin-help-text'>{field.help_text}</p>
      )}
      {isEditing || adminField ? (
        <div className='textarea-input'>
          <textarea
            rows={5}
            value={text}
            onChange={(e) => setText(e.target.value)}
            onBlur={(e) => handleSave(e)}
            placeholder={
              adminField && field.placeholder ? field.placeholder : ''
            }
          />
        </div>
      ) : (
        <div className='md'>
          <p>{response?.value ? decodeHTML(response.value) : ''}</p>
        </div>
      )}
    </div>
  );
};

export default TextAreaValue;
